var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 47.5 47.5",
    viewBox: "0 0 47.5 47.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38h38V0H0v38Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 47.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3b88c3",
    d: "M0 0a4 4 0 0 0-4-4h-28a4 4 0 0 0-4 4v28a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V0Z",
    transform: "translate(37 5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0c0-1.954-.836-3.659-2.542-4.744C-.31-5.768 1.24-7.845 1.24-10.294c0-3.721-3.41-6.852-7.813-6.852-4.589 0-7.441 3.379-7.441 5.829 0 1.209 1.271 2.077 2.388 2.077 2.108 0 1.612-3.628 5.115-3.628 1.613 0 2.915 1.24 2.915 2.884 0 4.34-5.271 1.147-5.271 4.806 0 3.255 4.402 1.054 4.402 4.495 0 1.179-.836 2.078-2.232 2.078-2.945 0-2.542-3.039-4.651-3.039-1.271 0-2.015 1.148-2.015 2.295 0 2.418 3.318 5.023 6.759 5.023C-2.139 5.674 0 2.418 0 0",
    transform: "translate(25.11 24.774)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.00b2b6c098727b2ef7dfc7b8ec4c8fde.svg";
export { ForwardRef as ReactComponent };